import * as actions from './actions';
import * as api from './api';
import * as functions from './functions';
import reducer from './reducer';

const reducers = {
  tournament: reducer,
};

export {
 api, reducers, actions, functions,
};
